/* eslint-disable import/prefer-default-export */
module.exports = function getFetchResponseCookies(response) {
    let cookieHeaders = [];

    if (response.headers && typeof response.headers.raw === 'function') {
        const rawCookieHeaders = response.headers.raw()['set-cookie'];
        if (Array.isArray(rawCookieHeaders)) {
            cookieHeaders = cookieHeaders.concat(rawCookieHeaders);
        }
    }

    return cookieHeaders.reduce((acc, cookie) => {
        const [name, value] = cookie.split(';')[0].split('=');
        acc[name] = value;
        return acc;
    }, {});
};
